import { render } from "./OurLovingClients.vue?vue&type=template&id=27b07e1b&scoped=true"
import script from "./OurLovingClients.vue?vue&type=script&lang=js"
export * from "./OurLovingClients.vue?vue&type=script&lang=js"

import "./OurLovingClients.vue?vue&type=style&index=0&id=27b07e1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b07e1b"]])

export default __exports__